import {useEffect, useState} from "react";
import {Link, useHistory} from "react-router-dom";
import {
    BrowserView,
    MobileView,
    isBrowser
} from "react-device-detect";

export function NavBarContent(props) {
    const history = useHistory();
    const TextTranslate = {
        flashpay2c: {
            ru: 'Система заказа и оплаты товаров через мобильное приложение для B2C',
            en: 'System for ordering and paying for goods through a mobile application for B2C'
        },
        flashpay2b: {
            ru: 'Система заказа и оплаты товаров через мобильное приложение для B2B',
            en: 'System for ordering and paying for goods through a mobile application for B2B'
        },
        flashid: {
            ru: 'Система бесконтактной авторизации клиента «ОДНИМ ВЗГЛЯДОМ»',
            en: 'Contactless client authorization system "AT A GLANCE"'
        },
        flashmedia: {
            ru: 'Платформа для размещения и управления рекламным контентом',
            en: 'Platform for placing and managing advertising content'
        },
        flashclient: {
            ru: 'Система распознавания клиента и его автомобиля на АЗС',
            en: 'The system for recognizing the customer and his/her car at the gas station'
        },
        // flashtalk: {
        //     ru: 'Защищенный и безопасный корпоративный мессенджер',
        //     en: 'Secure corporate messenger'
        // }
    };
    return (
        <div className={'text-nav-bar'}>
            <div className={'item-nav-bar-content'} onClick={() => {
                if(isBrowser){
                    history.push('/flashpay2c');
                    setTimeout(function () {
                        props.setisopenmenu(false);
                        props.setisclosed(true);
                    }, 200)
                }
            }}>
                <div className={'text-h-nav-bar'}>
                    {/*<Link to={'/flashpay2c'}>*/}
                    FlashPay2C
                    {/*</Link>*/}
                </div>
                <div className={'text-nav-bar-min section'} onClick={() => {
                        history.push('/flashpay2c');
                        setTimeout(function () {
                            props.setisopenmenu(false);
                            props.setisclosed(true);
                        }, 200)
                }}>
                    {/*<Link to={'/flashpay2c'}>*/}
                    {TextTranslate.flashpay2c[props.Lang]}
                    {/*</Link>*/}
                </div>
            </div>
            <div className={'item-nav-bar-content'} onClick={() => {
                if(isBrowser){
                    history.push('/flashpay2b');
                    setTimeout(function () {
                        props.setisopenmenu(false);
                        props.setisclosed(true);
                    }, 200)
                }
            }}>
                <div className={'text-h-nav-bar'}>
                    {/*<Link to={'/flashpay2b'}>*/}
                    FlashPay2B
                    {/*</Link>*/}
                </div>
                <div className={'text-nav-bar-min section'} onClick={() => {
                    history.push('/flashpay2b');
                    setTimeout(function () {
                        props.setisopenmenu(false);
                        props.setisclosed(true);
                    }, 200)
                }}>
                    {/*<Link to={'/flashpay2b'}>*/}
                    {TextTranslate.flashpay2b[props.Lang]}
                    {/*</Link>*/}
                </div>
            </div>
            <div className={'item-nav-bar-content'} onClick={() => {
                if(isBrowser){
                    history.push('/flashid');
                    setTimeout(function () {
                        props.setisopenmenu(false);
                        props.setisclosed(true);
                    }, 200)
                }
            }}>
                <div className={'text-h-nav-bar'}>
                    {/*<Link to={'/flashid'}>*/}
                    FlashID
                    {/*</Link>*/}
                </div>
                <div className={'text-nav-bar-min section'} onClick={() => {
                    history.push('/flashid');
                    setTimeout(function () {
                        props.setisopenmenu(false);
                        props.setisclosed(true);
                    }, 200)
                }}>
                    {/*<Link to={'/flashid'}>*/}
                    {TextTranslate.flashid[props.Lang]}
                    {/*</Link>*/}
                </div>
            </div>
            {/* <div className={'item-nav-bar-content'} onClick={() => {
                if(isBrowser){
                    history.push('/flashtalk');
                    setTimeout(function () {
                        props.setisopenmenu(false);
                        props.setisclosed(true);
                    }, 200)
                }
            }}>
                <div className={'text-h-nav-bar'}>
                    FlashTalk
                </div>
                <div className={'text-nav-bar-min section'} onClick={() => {
                    history.push('/flashtalk');
                    setTimeout(function () {
                        props.setisopenmenu(false);
                        props.setisclosed(true);
                    }, 200)
                }}>
                    {TextTranslate.flashtalk[props.Lang]}
                </div>
            </div> */}
            <div className={'item-nav-bar-content'} onClick={() => {
                if(isBrowser){
                    history.push('/flashmedia');
                    setTimeout(function () {
                        props.setisopenmenu(false);
                        props.setisclosed(true);
                    }, 200)
                }
            }}>
                <div className={'text-h-nav-bar'}>
                    {/*<Link to={'/flashmedia'}>*/}
                    FlashMedia
                    {/*</Link>*/}
                </div>
                <div className={'text-nav-bar-min section'} onClick={() => {
                    history.push('/flashmedia');
                    setTimeout(function () {
                        props.setisopenmenu(false);
                        props.setisclosed(true);
                    }, 200)
                }}>
                    {/*<Link to={'/flashmedia'}>*/}
                    {TextTranslate.flashmedia[props.Lang]}
                    {/*</Link>*/}
                </div>
            </div>
            <div className={'item-nav-bar-content'} onClick={() => {
                if(isBrowser){
                    history.push('/flashclient');
                    setTimeout(function () {
                        props.setisopenmenu(false);
                        props.setisclosed(true);
                    }, 200)
                }
            }}>
                <div className={'text-h-nav-bar'}>
                    {/*<Link to={'/flashclient'}>*/}
                    FlashClient
                    {/*</Link>*/}
                </div>
                <div className={'text-nav-bar-min section'} onClick={() => {
                        history.push('/flashclient');
                        setTimeout(function () {
                            props.setisopenmenu(false);
                            props.setisclosed(true);
                        }, 200)
                    }}>
                    {/*<Link to={'/flashclient'}>*/}
                    {TextTranslate.flashclient[props.Lang]}
                    {/*</Link>*/}
                </div>
            </div>
        </div>
    );
}

export function NavBar(props) {
    const [IsClosed, setIsClosed] = useState(false);
    const [MobileProductsOpen, setMobileProductsOpen] = useState(false);
    const TextTranslate = {
        feedback: {
            ru: 'ОСТАВИТЬ ЗАЯВКУ',
            en: 'CONTACT US'
        },
        products: {
            ru: 'ПРОДУКТЫ',
            en: 'PRODUCTS'
        },
        solutions: {
            ru: 'РЕШЕНИЯ',
            en: 'SOLUTIONS'
        },
        company: {
            ru: 'КОМПАНИЯ',
            en: 'COMPANY'
        }
    };
    useEffect(function () {
        setTimeout(function () {
            setIsClosed(false);
        }, 1000)
    }, [props.isopenmenu])
    return (
        <>
            <BrowserView>
                <div className={props.isopenmenu ? "Nav-bar nav-bar-open" : "Nav-bar"} onMouseLeave={() => {
                    props.setisopenmenu(false)
                }}>
                    <div className={"nav-bar-bottom"}>
                        <div className={"flex-class-left"}>
                            <div className={"logo-flex"} onClick={() => {
                                props.setisopenmenu(false)
                            }}>
                                <Link to={'/'}>
                                    <img src={"./OVERCOM_BW_logo 2.svg"} className={"logo"}/>
                                </Link>
                            </div>
                            <Link to={'/feedback'}>
                                <div className={"nav-bar-item nav-bar-background-button"}><span
                                    className={"span-bottom"}>{TextTranslate.feedback[props.Lang]}</span></div>
                            </Link>
                        </div>
                        <div className={"flex-class"}>
                            <div className={"content-nav-bar"}><NavBarContent
                                isopenmenu={props.isopenmenu}
                                setisopenmenu={props.setisopenmenu}
                                iscloset={IsClosed}
                                setisclosed={setIsClosed}
                                Lang={props.Lang}
                            /></div>
                            <div className={'nav-bar-line'}>
                                <div className={"nav-bar-item"} onMouseEnter={() => {
                                    if (!IsClosed) {
                                        props.setisopenmenu(true)
                                    }
                                }} onClick={() => {
                                    props.setisopenmenu(true)
                                }}><span className={"span-bottom span-bottom-min-w"}>{TextTranslate.products[props.Lang]}
                                    <i><img
                                        className={props.isopenmenu ? "arrow-style arrow-style-revert" : "arrow-style"}
                                        src={"/MENU_ARROW.svg"}/></i></span></div>
                                <div className={"nav-bar-item"}><span className={"span-bottom"}><Link
                                    to={'/solutions'}>{TextTranslate.solutions[props.Lang]} </Link></span></div>
                                <div className={"nav-bar-item"}><span className={"span-bottom"}><Link
                                    to={'/aboutcompany'}>{TextTranslate.company[props.Lang]}</Link></span></div>
                                <div className={"lang-box"}><span onClick={() => {
                                    props.senLang('ru')
                                }}
                                                                  className={props.Lang === 'ru' ? 'span-bottom ru-padding lang-box-active' : 'span-bottom ru-padding lang-box-inactive'}>RU </span><span
                                    className={"span-bottom lang-box-active"}>|</span><span onClick={() => {
                                    props.senLang('en')
                                }}
                                                                                            className={props.Lang === 'en' ? 'span-bottom en-padding lang-box-active' : 'span-bottom en-padding lang-box-inactive'}> EN</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </BrowserView>
            <MobileView>
                <div className={'mobile-nav-bar'}>
                    <div className={'mobile-nav-bar-top'}>
                        <Link to={'/'}>
                            <img src={"./OVERCOM_BW_logo 2.svg"} className={"logo-mobile"}/>
                        </Link>
                        <div>
                            <div id={'nav-icon4'} className={props.isopenmenu ? "open" : ''} onClick={
                                () => {
                                    if(props.isopenmenu){
                                        props.setisopenmenu(false);
                                    }
                                    else {
                                        props.setisopenmenu(true);
                                    }
                                }
                            }>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                    <div className={props.isopenmenu ? 'nav-bar-items-mobile nav-bar-items-mobile-open' : 'nav-bar-items-mobile'}>
                        <div className={'nav-bar-item-mobile'}>
                            <div onClick={() => {
                                if(MobileProductsOpen){
                                    setMobileProductsOpen(false);
                                }
                                else{
                                    setMobileProductsOpen(true);
                                }
                            }}>
                                <span className={"span-bottom span-bottom-min-w"}>{TextTranslate.products[props.Lang]}
                                    <i><img
                                        className={MobileProductsOpen ? "arrow-style" : 'arrow-style arrow-style-revert'}
                                        src={"/MENU_ARROW.svg"}/></i></span>
                            </div>
                            <div className={MobileProductsOpen ? 'nav-bar-mobile-content nav-bar-mobile-content-open' : 'nav-bar-mobile-content'}>
                                <NavBarContent
                                    isopenmenu={props.isopenmenu}
                                    setisopenmenu={props.setisopenmenu}
                                    iscloset={IsClosed}
                                    setisclosed={setIsClosed}
                                    Lang={props.Lang}
                                />
                            </div>
                        </div>
                        <div className={'nav-bar-item-mobile'} onClick={() => {
                            setTimeout(function () {
                                props.setisopenmenu(false);
                            }, 200)
                        }}>
                            <span className={"span-bottom"}><Link
                                to={'/solutions'}>{TextTranslate.solutions[props.Lang]} <i><img
                                src={"/LINK_ARROW.svg"}/></i></Link></span>
                        </div>
                        <div className={'nav-bar-item-mobile'} onClick={() => {
                            setTimeout(function () {
                                props.setisopenmenu(false);
                            }, 200)
                        }}>
                            <span className={"span-bottom"}><Link
                                to={'/aboutcompany'}>{TextTranslate.company[props.Lang]} <i><img
                                src={"/LINK_ARROW.svg"}/></i></Link></span>
                        </div>
                    </div>
                </div>
            </MobileView>
        </>
    );
}
